export const PANDA_VARIANTS = ['smile', 'wink', 'mail', 'cheer'] as const;

export type PandaVariant = (typeof PANDA_VARIANTS)[number];

function pickFrom(variants: readonly PandaVariant[], random: () => number): PandaVariant {
  const value = random();
  const bounded = Number.isFinite(value) ? Math.min(Math.max(value, 0), 0.999_999) : 0;
  return variants[Math.floor(bounded * variants.length)];
}

export function pickPandaVariant(random = Math.random): PandaVariant {
  return pickFrom(PANDA_VARIANTS, random);
}

export function pickNextPandaVariant(previous: string | null, random = Math.random): PandaVariant {
  const candidates = PANDA_VARIANTS.filter((variant) => variant !== previous);
  return pickFrom(candidates, random);
}
